import React from 'react';
import {tID} from '../../../utils/TestIdHelper';
import {transformImageUrl} from '../../../utils/HelperMethods';

const CachedImage = ({
  source,
  style = {},
  resizeMode = 'cover',
  testID = tID('CachedImage-Image-Source'),
}) => {
  const transformedSource = transformImageUrl(source);

  return (
    <img
      data-testid={testID}
      src={transformedSource}
      style={{...style, objectFit: resizeMode}}
    />
  );
};
export default CachedImage;
